export const StripedCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <mask
      id="mask0_40000863_11967"
      width="24"
      height="24"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#mask0_40000863_11967)">
      <path
        fill="#B45824"
        d="M6.967 5.808A7.76 7.76 0 0 1 11.2 4.01v1.638a7 7 0 0 0-1.648.44 6.3 6.3 0 0 0-1.468.838zm5.832-1.798a9.3 9.3 0 0 1 2.257.6 7.3 7.3 0 0 1 1.978 1.198l-1.119 1.118a6.3 6.3 0 0 0-1.468-.839 7 7 0 0 0-1.648-.439zM4.05 11.161q.12-1.179.57-2.247a8.3 8.3 0 0 1 1.188-1.988l1.159 1.119a7.5 7.5 0 0 0-.86 1.478 6.2 6.2 0 0 0-.459 1.638zm12.984-3.076 1.158-1.159a8.6 8.6 0 0 1 1.189 2.018q.45 1.078.57 2.257h-1.599a6.4 6.4 0 0 0-.46-1.648 7 7 0 0 0-.858-1.468M4.05 12.759h1.598q.12.879.45 1.668t.869 1.488l-1.159 1.159a8 8 0 0 1-1.199-2.028 8.3 8.3 0 0 1-.559-2.287m12.984 3.196q.519-.699.859-1.498t.46-1.658h1.597a8.147 8.147 0 0 1-1.758 4.275zM6.967 18.192l1.118-1.118a6.3 6.3 0 0 0 1.468.839q.79.32 1.648.439v1.638a9.3 9.3 0 0 1-2.257-.6 7.3 7.3 0 0 1-1.977-1.198m5.832.16a7 7 0 0 0 1.648-.44 6.3 6.3 0 0 0 1.468-.838l1.119 1.118a7.77 7.77 0 0 1-4.235 1.798z"
      />
    </g>
  </svg>
);
